const formatCurrency = (
  value: number,
  currencyCode: string,
  locale = navigator.language
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  });

  return formatter.format(value);
};

export { formatCurrency };
